export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 3;
export const ZOOM_STEP = 0.25;

export type ViewState = { zoom: number; panX: number; panY: number };
export type ViewAction =
    | { type: 'wheelZoom'; deltaY: number; cursorX: number; cursorY: number }
    | { type: 'pan'; dx: number; dy: number }
    | { type: 'zoomIn' }
    | { type: 'zoomOut' }
    | { type: 'reset' };

export const viewReducer = (
    state: ViewState,
    action: ViewAction,
): ViewState => {
    switch (action.type) {
        case 'wheelZoom': {
            const newZoom = Math.min(
                MAX_ZOOM,
                Math.max(
                    MIN_ZOOM,
                    state.zoom * Math.exp(-action.deltaY * 0.002),
                ),
            );
            // Keep the image point under the cursor fixed while zooming.
            // translate(panX,panY) is applied in screen space (outermost transform),
            // so the math reduces to: newPan = cursor + (pan - cursor) * ratio
            const ratio = newZoom / state.zoom;
            return {
                zoom: newZoom,
                panX: action.cursorX * (1 - ratio) + state.panX * ratio,
                panY: action.cursorY * (1 - ratio) + state.panY * ratio,
            };
        }
        case 'pan':
            return {
                ...state,
                panX: state.panX + action.dx,
                panY: state.panY + action.dy,
            };
        case 'zoomIn':
            return {
                ...state,
                zoom: Math.min(state.zoom + ZOOM_STEP, MAX_ZOOM),
            };
        case 'zoomOut':
            return {
                ...state,
                zoom: Math.max(state.zoom - ZOOM_STEP, MIN_ZOOM),
            };
        case 'reset':
            return { zoom: 1, panX: 0, panY: 0 };
    }
};
